// Compatibility layer: components import the *current* special through these names.
import { getSpecial } from './seasonalSpecials';

export const FALL_SPECIAL = (() => {
  const s = getSpecial();
  return { ...s, bookingPath: s.promoParam ? `/booking?promo=${s.promoParam}` : '/booking', expired: { title: s.title, tagline: s.tagline, bannerText: s.bannerText, intro: s.intro, ctaText: s.ctaText } };
})();

export const isFallSpecialActive = () => FALL_SPECIAL.active;

export const fallPromoCopy = () => {
  const s = FALL_SPECIAL;
  return { active: s.active, title: s.title, tagline: s.tagline, intro: s.intro, offer: s.offer, terms: s.terms, ctaText: s.ctaText, bannerText: s.bannerText, badgeText: s.badgeText, season: s.season, path: s.path, theme: s.theme };
};
